import React, { useState } from 'react'
import Portal from '@material-ui/core/Portal'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import InfoIcon from '@material-ui/icons/Info'
import CloseIcon from '@material-ui/icons/Close'

import { useBuildInfoStyles } from './build-info.styles'
import { useConfig } from '../../config'

export const BuildInfo: React.FC = () => {
  const [isShow, setIsShow] = useState(false)
  const config = useConfig()

  const classes = useBuildInfoStyles()

  if (!config.isDev) return null

  const handleToggleShow = () => {
    setIsShow(!isShow)
  }

  return (
    <Portal>
      <div className={classes.root}>
        {!isShow && (
          <IconButton onClick={handleToggleShow}>
            <InfoIcon />
          </IconButton>
        )}
        {isShow && (
          <Card variant="outlined">
            <IconButton
              className={classes.closeButton}
              onClick={handleToggleShow}
            >
              <CloseIcon />
            </IconButton>
            <CardContent className={classes.content}>
              <Typography className={classes.typography} gutterBottom>
                ветка: {config.branch}
              </Typography>
              <Typography className={classes.typography} gutterBottom>
                коммит: {config.commitHash}
              </Typography>
              <Typography className={classes.typography} gutterBottom>
                дата от: {config.buildDate}
              </Typography>
              <Typography className={classes.typography}>
                окружение: {config.env}
              </Typography>
            </CardContent>
          </Card>
        )}
      </div>
    </Portal>
  )
}
